<template>
	<div v-if="hasSelectedVvbOrders">
		<vs-button color="warning" @click="openVvbModal">
			<font-awesome-icon icon="cubes" class="mr-2" />
			(BETA) VVB bestellingen verwerken ({{ selectedVvbOrderCount }})
		</vs-button>
	</div>
</template>

<script>
export default {
	name: 'processvvbbutton',
	computed: {
		selectedOrderIds() {
			return this.$parent && this.$parent.selectedOrderIds ? this.$parent.selectedOrderIds : [];
		},
		orders() {
			return this.$parent && this.$parent.getOrders ? this.$parent.getOrders() : [];
		},
		selectedVvbOrders() {
			return this.orders.filter(order => {
				return this.selectedOrderIds.includes(order.order.id) && order.order && order.order.is_bol_vvb_order;
			});
		},
		selectedVvbOrderCount() {
			return this.selectedVvbOrders.length;
		},
		hasSelectedVvbOrders() {
			return this.selectedVvbOrderCount > 0;
		}
	},
	methods: {
		openVvbModal() {
			const modal = this.$parent && this.$parent.$refs && this.$parent.$refs.vvbprocessmodal;

			if (modal) {
				modal.vvbOrders = this.selectedVvbOrders;
				modal.selectedDeliveryOptions = {};
				modal.labelsDownloaded = false;
				modal.isDownloading = false;
				modal.isProcessing = false;

				modal.displayedVvbOrders.forEach(order => {
					const recommendedOption = order.delivery_options && order.delivery_options.find(opt => opt.recommended);
					modal.selectedDeliveryOptions[order.order.id] = recommendedOption ? recommendedOption.id : '';
				});

				modal.$set(modal, 'active', true);
			}
		}
	}
}
</script>
